import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetStoreTransferDetailsQuery } from '../slices/storeTransfersApiSlice';
import StoreTransferCarousel from '../components/StoreTransferCarousel';

const StoreTransferScreen = () => {
  const { id: storeTransferId } = useParams();

  const { data: storeTransfer, refetch, isLoading, error } = useGetStoreTransferDetailsQuery(storeTransferId);

  useEffect(() => {
    if (!storeTransfer) {
      refetch();
    }
  }, [storeTransfer, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>StoreTransfer {storeTransfer?._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {storeTransfer?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {storeTransfer?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {storeTransfer?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {storeTransfer?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {storeTransfer?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreTransfer Note</h2>
              <p>{storeTransfer?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreTransfer Items</h2>
              {storeTransfer?.storeTransferItems?.length === 0 ? (
                <Message>This storeTransfer has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {storeTransfer?.storeTransferItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>StoreTransfer Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{storeTransfer?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${storeTransfer?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{storeTransfer?.status || 'N/A'}</Col>
                  <Col>{storeTransfer?.username || 'No user name provided'}</Col>
                  <Col md={6}>
                                              {/* Display expense images using StoreTransferCarousel */}
                                              {storeTransfer.images && storeTransfer.images.length > 0 ? (
                                                <StoreTransferCarousel images={storeTransfer.images} />
                                              ) : (
                                                <Message variant="info">No images available for this expense</Message>
                                              )}
                   </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StoreTransferScreen;